<template>
  <small class="warning-text">
    This child has already joined a waitlist for this center.
  </small>
</template>

<style lang="scss" scoped>
.warning-text {
  color: red;
}
</style>
